module.exports = "/_next/static/images/pizzagama-02c0f8ab379fdae4584acbbfefc6c940.jpg";